const FAQ_BLOCK = /(<div\b[^>]*\bdata-ds-block="faq"[^>]*>)([\s\S]*?)(<\/div>)/gi;
const H3_START = /<h3\b/i;

/**
 * Transforma cada par pergunta/resposta do bloco `faq` em `<details>` com a
 * pergunta no `<summary>` — o abrir/fechar do FAQ, sem JS.
 *
 * Roda sobre o HTML **já sanitizado**, igual ao `addHeadingIds`: o conteúdo
 * salvo continua `<h3>` + `<p>` (editor, Markdown e prompt da IA não mudam) e
 * o `details`/`summary` é gerado por nós, nunca vindo do editor. Cliente
 * (`PostBody`) e SSR (`renderPostBody`) chamam a mesma função, então o crawler
 * recebe a mesma marcação que o React renderiza.
 *
 * Por que `details` e não resposta escondida por CSS: a resposta continua no
 * HTML (o crawler indexa), o leitor de tela anuncia "recolhido/expandido" de
 * graça, e o Ctrl+F do navegador abre o item que contém o termo buscado.
 *
 * O bloco só tem `h3` e `p` (forma em `BLOCK_SHAPES`), por isso o `</div>`
 * mais próximo fecha o bloco. Texto antes da primeira pergunta fica como está.
 * Idempotente: bloco que já tem `<details>` não é tocado.
 */
export const addFaqAccordion = (html: string): string =>
  html.replace(FAQ_BLOCK, (match, open: string, inner: string, close: string) => {
    if (/<details\b/i.test(inner)) return match;

    const first = inner.search(H3_START);
    if (first < 0) return match;

    const items = inner
      .slice(first)
      .split(/(?=<h3\b)/i)
      .map(item => {
        const end = item.search(/<\/h3>/i);
        if (end < 0) return item;
        const question = item.slice(0, end + "</h3>".length);
        const answer = item.slice(end + "</h3>".length);
        return `<details><summary>${question}</summary>${answer}</details>`;
      });

    return `${open}${inner.slice(0, first)}${items.join("")}${close}`;
  });
